var MembershipMixin = {
	computed: {
		isMembership() {
			const datetimeMembershipExpire = this.$store.state.datetimeMembershipExpire;
			return datetimeMembershipExpire !== null && datetimeMembershipExpire > new Date;
		}
	},
};


export { MembershipMixin };
